/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_Group_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to remove group. {error}" |
*
* @param {Team_Manager_Remove_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_failed = /** @type {((inputs: Team_Manager_Remove_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la suppression du groupe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gruppe konnte nicht entfernt werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile rimuovere il gruppo. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить группу. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar el grupo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除组失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループの削除に失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह को हटाने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao remover o grupo. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to remove group. ${i?.error}`)
});